import { TestImage } from "@assets/constant/index.constant";
import { endpoint } from "@services/api.services";
import { METHODS } from "@services/interface.service";
import { GeneralCard, TableCard } from "@ui/internal/components/card";
import FilterPopover from "@ui/internal/components/filter-popover";
import { formatNumber } from "@utils/helper/index.helper";
import { usePathname } from "@utils/hook/index.hook";
import { QueryMetaData } from "@utils/interface/index.interface";
import { TestimonialData } from "@utils/interface/journey.interface";
import { useListData, usePostData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import { format } from "date-fns";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
import TestimonialForm from "./form/index.form";

type Props = {};
interface SelectionProps {
  description: number;
  video: number;
}
const index: React.FC<Props> = ({}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { search, date } = useMetaStore();
  const pathname = usePathname();
  /* ================================================= api calls logic ================================================= */
  const { data, isPending, refetch, error } = useListData<
    QueryMetaData<TestimonialData, SelectionProps>
  >({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      test: "ok",
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
      is_show: searchParams.get("status") || "",
      testimonial_type:
        searchParams
          .get("data-category")
          ?.toLocaleLowerCase()
          ?.split("-")[0] === "all"
          ? ""
          : searchParams
              .get("data-category")
              ?.toLocaleLowerCase()
              ?.split("-")[0] || "",
    },
    endpoint: endpoint["testimonial"],
    key: `${pathname}-listing`,
    window: true,
  });
  useEffect(() => {
    if (
      //@ts-ignore
      error?.status === 404 &&
      error?.data?.detail === "Invalid page."
    ) {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);

  const groupRefetch = () => {
    refetch();
  };
  const { mutate } = usePostData();
  const toggleActiveStatus = (id: string | number, state: boolean) => {
    mutate(
      {
        endpoint: endpoint["testimonial"],

        data: {
          is_show: state,
          id,
        },
        method: METHODS.PATCH,
      },
      {
        onSuccess: () => {
          if (data) {
            const newItems = data.data.results.map((item) =>
              item.id === id ? { ...item, is_show: state } : item
            );
            console.log("new items", newItems);
            data.data.results = newItems;
          }
        },
        onError: (data) => {
          console.log(data);
        },
      }
    );
  };

  const columns = ColumnList({ refetch: groupRefetch, toggleActiveStatus });
  return (
    <>
      <TableCard
        bulkActions
        formId={pathname + (searchParams.get("tab") || "description")}
        table_content={{
          mode: "default",
          type: pathname,
        }}
        form={<TestimonialForm />}
        showOrientationSecond
        tableHeaderData={[
          {
            id: 1,
            name: "All",
            count: formatNumber(data?.data?.total_count || 0),
          },
          {
            id: 2,
            name: "Description",
            count: formatNumber(
              Number(data?.data?.sections?.description) || 0
            ) as number,
          },
          {
            id: 3,
            name: "Video",
            count: formatNumber(
              Number(data?.data?.sections?.video) || 0
            ) as number,
          },
        ]}
        grid={
          <GeneralCard
            isChecked={false}
            type={"testimonial"}
            showCheck
            content={{
              username: "Yunika Shakya",
              userdesignation: "UI/UX Designer",
              userimage: TestImage || "",
              image: TestImage || "",
              description:
                "Digital Marketing Mentorgital Marketing Mentorgital Marketing Mentor",
            }}
            onToggleStatus={toggleActiveStatus}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        inject_ui_table_actions={
          <FilterPopover
            filters={[
              {
                label: "Testimonial Status",
                searchKey: "status",
                radio: true,
                defaultOptions: [
                  {
                    label: "Featured",
                    value: "true",
                  },
                  {
                    label: "Non-Featured",
                    value: "false",
                  },
                ],
              },
            ]}
          />
        }
        sortableFilter={{
          search,
          ordering: searchParams.get("ordering") || "order",
          is_show: searchParams.get("status") || "",
          section:
            searchParams
              .get("data-category")
              ?.toLocaleLowerCase()
              ?.split("-")[0] === "all"
              ? ""
              : searchParams
                  .get("data-category")
                  ?.toLocaleLowerCase()
                  ?.split("-")[0] || "",
        }}
        endpoint={endpoint["testimonial"]}
        columns={columns}
        rows={data?.data?.results ?? []}
        refetch={groupRefetch}
        isPending={isPending}
        count={data?.data?.count ?? 10}
      />
    </>
  );
};

export default index;
